import { useState } from "react";

const useToggleTranscription = () => {
  const [isTranscriptionActive, setIsTranscriptionActive] = useState(false);

  const toggleTranscription = () => {
    const newState: boolean = !isTranscriptionActive;
    setIsTranscriptionActive(newState);
  };

  return { isTranscriptionActive, toggleTranscription };
};

export default useToggleTranscription;
